//package/index.js
import map3DViewer from "../package/3d/map-3d-viewer/index.vue"; // 引入地图组件
import layerManagement from "../package/3d/layer-management/index.vue"; // 引入地图组件
import DyButton from "../package/dy-button/index.vue"; // 引入封装好的组件
import ToolBar from "../package/3d/tool-bar/index.vue";
import dy3dMap from "../package/3d/js/dy3dMap.js"
import '../assets/less/common.less'
const coms = [DyButton,map3DViewer,ToolBar,layerManagement]; // 将来如果有其它组件,都可以写到这个数组里

// import Antd from "ant-design-vue";
// import vueBus from './utils/vueBus';

// import 'ant-design-vue/dist/antd.css';

// 批量组件注册
const install = function (Vue) {
  // Vue.use(Antd)
  // Vue.use(vueBus);
  coms.forEach((com) => {
    Vue.component(com.name, com);
  });
};

export default install; // 这个方法以后再使用的时候可以被use调用   
export { DyButton,map3DViewer,ToolBar,layerManagement,dy3dMap }; // 单独引入组件时,需要暴露出这些组件